import { Observable } from "rxjs";
import { CommonHttpOption } from "./../../base/common-http-option";
import { ServiceRoute } from "src/app/services/http/base/service-route";
import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";

@Injectable({
  providedIn: "root"
})
export class InvoiceService {
  constructor(private core: CoreService) { }

  invoiceCompanyGetById(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.invoce.getInvoiceAllById + id,
      new CommonHttpOption().headers
    );
  }

  invoiceComon(): Observable<any> {
    return this.core.get(
      ServiceRoute.invoce.InvoiceComon,
      new CommonHttpOption().headers
    );
  }

  addAghInvoice(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.invoce.addAghInvoice,
      data,
      new CommonHttpOption().headers
    );
  }

  calcAghPlacementInvoice(contractId: number): Observable<any> {
    return this.core.get(
      ServiceRoute.invoce.calcAghPlacementInvoice + contractId,
      new CommonHttpOption().headers
    );
  }

  calcAghRegistrationInvoice(contractId: number): Observable<any> {
    return this.core.get(
      ServiceRoute.invoce.calcAghRegistrationInvoice + contractId,
      new CommonHttpOption().headers
    );
  }

  invoiceCompany(filter: any, pageIndex: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.invoce.invoiceCompany,
      new CommonHttpOption().headers,
      new CommonHttpOption()
        .paginator(pageIndex, pageSize, "Id", true)
        .append('FullName', filter && filter.FullName ? filter.FullName : '')
        .append('InvoiceItemTypeId', filter && filter.InvoiceItemTypeId ? filter.InvoiceItemTypeId : '')
        .append('InvoiceStatusId', filter && filter.InvoiceStatusId ? filter.InvoiceStatusId : '')
        .append('NationalCode', filter && filter.NationalCode ? filter.NationalCode : '')
        .append('CreationDateInvoiceStart', filter && filter.CreationDateInvoiceStart ? filter.CreationDateInvoiceStart : '')
        .append('CreationDateInvoiceEnd', filter && filter.CreationDateInvoiceEnd ? filter.CreationDateInvoiceEnd : '')
        .append('PriceStart', filter && filter.PriceStart ? filter.PriceStart : '')
        .append('PriceEnd', filter && filter.PriceEnd ? filter.PriceEnd : '')
        .append('PayPersonName', filter && filter.PayPersonName ? filter.PayPersonName : '')
        .append('InvoiceCounterNumber', filter && filter.InvoiceCounterNumber ? filter.InvoiceCounterNumber : '')
        .append('BranchEncryptId', filter && filter.BranchEncryptId ? filter.BranchEncryptId : '')
    );
  }

  getInvoiceVoucherRowForStudent(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.invoce.getInvoiceVoucherRowForStudent + params.Id,
      new CommonHttpOption().headers,
    );
  }

  cancelInvoice(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.invoce.CancelInvoce,
      new CommonHttpOption().headers,
      data
    );
  }

  getInvoiceInfoById(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.invoce.getInvoiceInfoById + params.Id,
      new CommonHttpOption().headers,
    );
  }

  invoiceCompanyAll(filter: any, pageIndex: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.invoce.invoiceCompanyAll,
      new CommonHttpOption().headers,
      new CommonHttpOption()
        .paginator(pageIndex, pageSize, "Id", true)
        .append('FullName', filter && filter.FullName ? filter.FullName : '')
        .append('InvoiceItemTypeId', filter && filter.InvoiceItemTypeId ? filter.InvoiceItemTypeId : '')
        .append('InvoiceStatusId', filter && filter.InvoiceStatusId ? filter.InvoiceStatusId : '')
        .append('NationalCode', filter && filter.NationalCode ? filter.NationalCode : '')
        .append('CreationDateInvoiceStart', filter && filter.CreationDateInvoiceStart ? filter.CreationDateInvoiceStart : '')
        .append('CreationDateInvoiceEnd', filter && filter.CreationDateInvoiceEnd ? filter.CreationDateInvoiceEnd : '')
        .append('PriceStart', filter && filter.PriceStart ? filter.PriceStart : '')
        .append('PriceEnd', filter && filter.PriceEnd ? filter.PriceEnd : '')
        .append('PayPersonName', filter && filter.PayPersonName ? filter.PayPersonName : '')
        .append('InvoiceCounterNumber', filter && filter.InvoiceCounterNumber ? filter.InvoiceCounterNumber : '')
    );
  }

  paymnetConfirmation(InvoiceOnlinePaymentId: any): Observable<any> {
    return this.core.get(
      ServiceRoute.invoce.paymnetConfirmation + InvoiceOnlinePaymentId,
      new CommonHttpOption().headers
    );
  }
}
